import { AnalysisFileType } from "../../../types/analysisFileTypes";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../../scaffold/ui/LinkTypes";
import GenericAnalysisFilesAdminPage from "./GenericAnalysisFileAdminPage";


export default function DirectPayoutAnalysisFilesAdminPage() {
    return <GenericAnalysisFilesAdminPage
        fileType={AnalysisFileType.DirectPayoutAnalysisFile}
        title={SidebarLinkTypes.superAdminAnalysisFilesDirectPayout}
        link={SidebarLinkPathTypes.superAdminAnalysisFilesDirectPayout}
    />
}